import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { API } from 'aws-amplify';
import { LobbypageService } from 'src/app/services/lobbypage.service';

@Component({
  selector: 'app-filter-matches',
  templateUrl: './filter-matches.page.html',
  styleUrls: ['./filter-matches.page.scss'],
})
export class FilterMatchesPage implements OnInit {
  filterArray: any[] = [];
  language: string;
  @Input() set selectedArray(data: any[]) {
    this._tempArray = data;
  }

  get selectedArray() {
    return this._tempArray;
  }

  isChecked: boolean = false;
  _tempArray: any[] = [];
  currentTimeInSeconds: number = new Date().getTime();
  matches: string[] = [];
  filteredMatches: any[] = [];
  constructor(
    private lobbyService: LobbypageService,
    private modal: ModalController,
    private translate: TranslateService,
  ) { }

  ionViewWillEnter() {
     this.getMatches();
    this.language = localStorage.getItem("language");
    if (this.language === 'hn') {
      this.translate.use('hn');
    }
    else if (this.language === 'en') {
      this.translate.use('en');
    }
    else if (this.language === 'kn') {
      this.translate.use('kn');
    }
  }

  ngOnInit() {
     this.getMatches()
    // console.log("filterArray",this.filterArray);
  }
  
  ionViewDidEnter() {
    for (const filter of this.selectedArray) {
      document.getElementById(filter).click();
    }
  }
  getMatches() {
    // console.log("call getMatches1");
    const apiName = 'matchesApi';
    const path = `/matches/?${this.currentTimeInSeconds}&gameId=1&sportId=1`;
    const myInit = {
      headers: {},
      response: true,
      queryStringParameters: {}
    };
    API.get(apiName, path, myInit).then((data) => {
      data?.data?.data?.matches.sort((a, b) => b.isPinned - a.isPinned || a.timeStampStart - b.timeStampStart);
       this.filteredMatches = data?.data?.data?.matches;
       for (let i = 0; i < this.filteredMatches.length; i++) {
        if (this.filterArray.indexOf(this.filteredMatches[i].series) === -1) {
          this.filterArray.push(this.filteredMatches[i].series);
        }
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  clickSelectBox(itemKey) {
    const foundAt = this.matches.indexOf(itemKey);
    if (foundAt >= 0) {
      this.matches.splice(foundAt, 1);
    } else {
      this.matches.push(itemKey);
    }
  }

  selectAll() {
    setTimeout(() => {
      const matches = this.matches.length;
      for (let i = 0; i < matches; i++) {
        document.getElementById(this.matches[0]).click();
      }
    }, 100);
  }

  applyFilter() {
    console.log(this.matches);
    this.modal.dismiss(this.matches);
  }
  // ionViewDidLeave() {
  //   console.log(this.filterArray);
  //   this.filterArray = null;
  // }

  clearFilter() {
    this.modal.dismiss([]);
  }
}
